import './brand-logo.css';

interface BrandLogoProps {
  readonly src: string;
  readonly srcDark?: string;
  readonly alt: string;
  readonly className?: string;
}

export function BrandLogo({
  src,
  srcDark,
  alt,
  className,
}: BrandLogoProps): React.JSX.Element {
  // No dark variant supplied: a single image renders on every scheme.
  if (!srcDark) {
    return <img src={src} alt={alt} className={className} />;
  }

  // Scheme-aware swap: both lockups ship and CSS reveals the one matching the
  // active Mantine color scheme, so the mark stays legible on its card surface
  // (white in light, navy in dark). The hidden variant is display:none, so
  // screen readers announce the alt text only once.
  const variantClass = (variant: 'light' | 'dark'): string =>
    [className, `brand-logo--${variant}`].filter(Boolean).join(' ');

  return (
    <>
      <img src={src} alt={alt} className={variantClass('light')} />
      <img src={srcDark} alt={alt} className={variantClass('dark')} />
    </>
  );
}

export default BrandLogo;
